import {
  Component,
  EventEmitter,
  Output,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalService } from '../../global/services/global.service';
import { WorkspaceService } from '../../workspace/workspace.service';
import { AppService } from '../../app.service';
import {
  buildHeaderDataShell,
  normalizeFilterParams,
  rowPayloadFromActiveScreen,
  hydratedGlobalParams,
} from '../../shared/workspace-element-context';

/**
 * Angular CE container for workflow main.
 */
@Component({
    selector: 'gtw-workflow-main',
    templateUrl: './workflow-main.component.html',
    styleUrls: ['./workflow-main.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class WorkflowMainComponent implements OnInit, OnDestroy {
  private readonly subs = new Subscription();

  @Output('request-grid-update') requestGridUpdate = new EventEmitter<string>();

  rowData: any = {};
  filterParams: any = {};
  globalService: any = {};
  GENERAL_CONFIG: any = {};
  private isInitialized = false;
  private isLoading = false;
  showFormLoader = true;
  tabs: string[] = ['Entity List'];
  activeTab = 'Entity List';

  constructor(
    private cdr: ChangeDetectorRef,
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService
  ) {}

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.subs.add(
      this.gtwWorkspace.setTabActive.subscribe(() => {
        this.applyWorkspaceContext();
      })
    );
    this.subs.add(
      this.gtwGlobal.globalParamsChanged$.subscribe(() => {
        this.applyWorkspaceContext();
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    this.isInitialized = false;
    this.isLoading = false;
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    const header = buildHeaderDataShell(this.gtwGlobal, this.gtwApp);
    header.globalParams = hydratedGlobalParams(this.gtwGlobal, this.gtwWorkspace) || header.globalParams || {};
    this.GENERAL_CONFIG = header.generalConfigData || {};
    this.globalService = header;
    this.filterParams = normalizeFilterParams(activeScreen);
    this.rowData = rowPayloadFromActiveScreen(activeScreen);
    this.tryInit();
    this.cdr.markForCheck();
  }

  private tryInit(): void {
    if (this.isInitialized || this.isLoading) return;
    if (!this.GENERAL_CONFIG?.base_url && !this.GENERAL_CONFIG?.api_url) return;
    if (!this.filterParams || Object.keys(this.filterParams).length === 0) return;
    this.isLoading = true;
    this.isInitialized = true;
    this.showFormLoader = false;
    this.isLoading = false;
    this.cdr.detectChanges();
  }

  setTab(tab: string): void {
    this.activeTab = tab;
    this.cdr.detectChanges();
  }

  refresh(): void {
    this.requestGridUpdate.emit('refresh');
  }

  cancel(): void {
    this.requestGridUpdate.emit('cancel');
  }

  get rowDataKeys(): string[] {
    return this.rowData && typeof this.rowData === 'object' ? Object.keys(this.rowData) : [];
  }
}
